import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { font, WebfontLoader } from '@chegg-ui/theme';
import { ResetStyles } from './reset';
export var BaseStyles = createGlobalStyle(["body{font-size:16px;line-height:1.25;font-family:", ";}"], font.family["default"]);
export var GlobalStyles = function GlobalStyles() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WebfontLoader, null), /*#__PURE__*/React.createElement(ResetStyles, null), /*#__PURE__*/React.createElement(BaseStyles, null));
};